export default __webpack_public_path__ + "swg-icons.8bc08722.woff";